export default __webpack_public_path__ + "static/media/register_footer_rebrand.ae17c16c.png";